import { finishRequestTiming, startRequestTiming } from "../performance/requestTiming";

const API_BASE_URL = (process.env.REACT_APP_ANINA_AUTH_API_URL || "http://localhost:8000").replace(/\/$/, "");
let sessionRequestInFlight = null;

async function request(path, options = {}) {
  const method = options.method || "GET";
  const timing = startRequestTiming("auth", path);

  try {
    const response = await fetch(`${API_BASE_URL}${path}`, {
      credentials: "include",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(method !== "GET" ? { "X-CSRF-Intent": "anina-auth-v1" } : {}),
        ...(options.headers || {}),
      },
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (error) {
      payload = null;
    }

    if (!response.ok) {
      const detail = payload?.detail || "Authentication request failed.";
      throw new Error(detail);
    }

    finishRequestTiming(timing, "ok");
    return payload;
  } catch (error) {
    finishRequestTiming(timing, error?.name === "AbortError" ? "aborted" : "error");
    throw error;
  }
}

export function getSession() {
  if (!sessionRequestInFlight) {
    sessionRequestInFlight = request("/auth/session").finally(() => {
      sessionRequestInFlight = null;
    });
  }
  return sessionRequestInFlight;
}

export function signIn(email, password) {
  return request("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function signUp(email, password) {
  return request("/auth/signup", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function signOut() {
  return request("/auth/logout", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function requestPasswordReset(email) {
  return request("/auth/password-reset/request", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export function establishRecoverySession(accessToken, refreshToken) {
  return request("/auth/recovery/session", {
    method: "POST",
    body: JSON.stringify({
      access_token: accessToken,
      refresh_token: refreshToken,
    }),
  });
}

export function updatePassword(password) {
  return request("/auth/password-reset/update", {
    method: "POST",
    body: JSON.stringify({ password }),
  });
}

export function getAdminStatus() {
  return request("/admin/status");
}

export function getOwnerStatus() {
  return request("/owner/status");
}

export function getOwnerOverview() {
  return request("/owner/overview");
}


export function grantComplimentaryAccess(userId, reason = null, expiresAt = null) {
  return request("/owner/complimentary-access/grant", {
    method: "POST",
    body: JSON.stringify({
      user_id: userId,
      reason,
      expires_at: expiresAt,
    }),
  });
}

export function revokeComplimentaryAccess(userId, reason = null) {
  return request("/owner/complimentary-access/revoke", {
    method: "POST",
    body: JSON.stringify({
      user_id: userId,
      reason,
    }),
  });
}

export function getNinaAccessContext() {
  return request("/nina/access-context");
}
